import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '@/theme/ThemeProvider';
import { cn } from '@/lib/utils';

const Toaster = ({ toastOptions, ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      // A modal Radix layer (Sheet/Dialog) sets `pointer-events: none` on
      // <body>, which the portaled toaster inherits — an "Undo" toast under an
      // open sheet would be dead to clicks. Re-enabling pointer events on each
      // toast keeps its action clickable while the sheet stays modal.
      toastOptions={{ ...toastOptions, className: cn('pointer-events-auto', toastOptions?.className) }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
